import '../dashboard/dashboard-reset.css';
import { NewMembershipsEmailCapture } from './NewMembershipsEmailCapture';

/** Standalone paused-memberships page for gated acquisition routes. */
export function NewMembershipsClosedPage() {
  return (
    <div className="dashboard-reset flex min-h-svh flex-col bg-catch-tan">
      <main className="mx-auto w-full max-w-md flex-1 px-5 pt-16 pb-12">
        <NewMembershipsEmailCapture />
      </main>
    </div>
  );
}
